import { api } from '@/shared/api';

export const fetchHotels = async (groupId: string) => {
    return api.get('/hotel-groups/{group_id}/hotels', {
        path: {
            group_id: groupId,
        },
    });
};
